var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex overflow-hidden mw-100"},[_c('iframe',{ref:"frame",staticClass:"iframe border-0",style:({ width: this.options.width }),attrs:{"srcdoc":_vm.iframeContent}})])}
var staticRenderFns = []

export { render, staticRenderFns }